// Hash routes (#/people/alex), so a reload or a shared link lands on the same screen. The hash
// never carries data, only screen names and record ids.

import { useEffect, useState } from "react";

export const currentRoute = () => window.location.hash.replace(/^#\/?/, "").split("?")[0].split("/").filter(Boolean).map(decodeURIComponent);

export function useRoute(): string[] {
  const [route, setRoute] = useState(currentRoute);
  useEffect(() => {
    const onChange = () => setRoute(currentRoute());
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);
  return route;
}

export const href = (...parts: string[]) => `#/${parts.map(encodeURIComponent).join("/")}`;

export const go = (...parts: string[]) => {
  window.location.hash = href(...parts);
};
